export const permission_list = [

  {

    id: 1,
    label: "Dashboard",
    path: "/dashboard",
    expanded: true,
  },
  {
    id: 2,
    label: "Venues",
    path: "/venues",
    expanded: true,
    items: [
      {
        id: 3,
        label: "List Venues",
        path: "/venues",
      },
      {
        id: 4,
        label: "Add Venues",
        path: "/venue/add"
      },
      {
        id: 5,
        label: "Edit Venues",
        path: "/venue/edit"
      },
      {
        id: 6,
        label: "Show Venues",
        path: "/venue/view"
      },

    ]
  },
  {
    id: 7,
    label: "Bookings",
    path: "/bookings",
  },
  {
    id: 8,
    label: "Statistics",
    path: "/statistics",
  },
  {
    id: 9,
    label: "Companies",
    path: "/companies",
  },
  {
    id: 10,
    label: "Payments",

    path: "/payments",
  },
  {
    id: 11,
    label: "Services",
    path: "/services/SMSPAY",
    expanded: true,
    items: [
      {
        id: 12,
        label: "Show Sms payments",
        path: "/services/SMSPAY",
        key:'Services'
      },
      {
        id: 13,
        label: "Make payment link",
        path: "/services/pay-by-link",
        key:'Services'

      },
      {
        id: 14,
        label: "Make Refund",
        path: "/refund",
      },

    ]
  },

];
